import { List, ListIcon, ListItem } from '@chakra-ui/react';
import { ReactComponent as Check } from 'resources/images/checkmark.svg';

export interface StorageFeatureListProps {
  featureList: string[];
}

export const StorageFeatureList = ({
  featureList,
}: StorageFeatureListProps) => {
  return (
    <List spacing={2} color="M.70" fontSize="sm" lineHeight="normal">
      {featureList.map((feature, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItem key={index}>
          <ListIcon as={Check} w={4} h={4} color="B.80" />
          {feature}
        </ListItem>
      ))}
    </List>
  );
};
